import React, { useEffect, useState } from 'react'
import { useNavigate, useLocation, Routes, Route } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import TopButton from '../Components/TopButton'
import { http, httpAuth } from '../Service/http'
import { notify } from '../Utils/notify'
import { AuthService } from '../Service/auth'
import Header from '../Components/Header/Header'
import SwitcPage from './SwitcPage'
import LoginPage from './LoginPage'
import { auth } from './../store/auth'

export default function IndexPage() {
	const navigate = useNavigate()
	const { t, i18n } = useTranslation()

	const [Loading, setLoading] = useState(false)
	const { pathname } = useLocation()

	useEffect(() => {
		httpAuth.interceptors.request.use(
			config => {
				config.params = {
					...config.params,
					lang: i18n.language
				}
				return config
			},
			error => {
				return Promise.reject(error)
			}
		)
		http.interceptors.request.use(
			config => {
				config.params = {
					...config.params,
					lang: i18n.language
				}
				return config
			},
			error => {
				return Promise.reject(error)
			}
		)

		http.interceptors.response.use(
			response => {
				return response
			},
			error => {
				if (error.response === undefined) {
					// server is not responding
					let errorObject = JSON.parse(JSON.stringify(error))
					if (errorObject.status === null) {
						return {
							status: 521,
							message: t('axios.internetError'),
							error: true,
							data: null
						}
					}
					return {
						status: 522,
						message: t('axios.unknownError'),
						error: true,
						data: null
					}
				}

				if (error.response.status === 401 && window.location.pathname.includes(`/login`) === false) {
					if (error.response.status === 401) {
						// user is not authenticated
						auth.newUser({
							isAuthenticated: false,
							data: {
								AVN20: 0,
								AVN_BT_report: 0,
								doljnost: 0,
								id: 0,
								name: ''
							},
							isLoading: false
						})
						navigate(`/bt/login`)

						if (error.response.config.url.includes('auth/check') === false) {
							// user is not on login page and not on auth/check , session is expired when user is working
							notify(t('axios.sessionExpired'), 'error')
							throw 'Срок сессии истек!'
						}

						return Promise.reject(error)
					}
					const data = { ...error.response.data, status: error.response.status }
					return data
				}
			}
		)
		httpAuth.interceptors.response.use(
			response => {
				// const data = { ...response.data, status: response.status };
				return { ...response.data, status: response.status }
			},
			error => {
				if (error.response === undefined) {
					// server is not responding
					let errorObject = JSON.parse(JSON.stringify(error))
					if (errorObject.status === null) {
						return {
							status: 521,
							message: t('axios.internetError'),
							error: true,
							data: null
						}
					}
					return {
						status: 522,
						message: t('axios.unknownError'),
						error: true,
						data: null
					}
				}

				if (error.response.status === 401 && window.location.pathname.includes(`/login`) === false) {
					if (error.response.status === 401) {
						// user is not authenticated
						auth.newUser({
							isAuthenticated: false,
							data: {
								AVN20: 0,
								AVN_BT_report: 0,
								doljnost: 0,
								id: 0,
								name: ''
							},
							isLoading: false
						})
						navigate(`/bt/login`)

						if (error.response.config.url.includes('auth/check') === false) {
							// user is not on login page and not on auth/check , session is expired when user is working
							notify(t('axios.sessionExpired'), 'error')
							throw 'Срок сессии истек!'
						}

						return Promise.reject(error)
					}
					const data = { ...error.response.data, status: error.response.status }
					return data
				}
			}
		)

		AuthService.check()
			.then(({ data, error, message, status }) => {
				if (error) {
					auth.newUser({
						isAuthenticated: false,
						data: {
							AVN20: 0,
							AVN_BT_report: 0,
							doljnost: 0,
							id: 0,
							name: ''
						},
						isLoading: false
					})
					notify(message, 'error')
				} else {
					notify(message, 'success')
					auth.newUser({ isAuthenticated: true, data: data, isLoading: false })
					if (window.location.pathname.includes(`/login`)) {
						// if in login page and auth=true
						navigate(`/bt/students`)
					} else {
						// if not in login page and auth=true
						navigate(`${pathname}${window.location.search}`)
					}
				}
				setLoading(false)
			})
			.catch(err => {})
	}, [])

	if (Loading) {
		return <div>{t('loading')}</div>
	}

	return (
		<div className='MainPage'>
			<Header />
			<div style={{ marginTop: 50 }}>
				<Routes>
					<Route path='/bt/login' element={<LoginPage />} />
					<Route path='/bt/' element={<SwitcPage />} />
					<Route path='/bt' element={<SwitcPage />} />
					<Route path='*' element={<SwitcPage />} />
				</Routes>
			</div>
			<TopButton />
		</div>
	)
}
